import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Modal, Button, Form } from 'react-bootstrap';
import { putRequest } from '../../helpers/apiHandler';
import CustomAlert from '../../components/CustomAlert';
import config from '../../config/Constant';
import GlobalRatesConfirmModel from './GlobalRatesConfirmModel';
import CloseIcon from '../../layouts/SVG/CloseIcon';

const GlobalRatesUpdateModel = ({ show, onClose, rowData, getGlobalRatesData }) => {
  const { access_token } = useSelector((state) => state.auth.user);
  const { id, country, name, myr_cost } = rowData;
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [newMYRCost, setnewMYRCost] = useState(myr_cost);
  const [alertState, setAlertState] = useState({
    show: false,
    variant: 'danger',
    message: '',
  });

  const showConfirm = () => {
    onClose();
    setnewMYRCost(newMYRCost);
    setShowConfirmModal(true);
  };

  const handleEditRate = () => {
    const data = {
      id: id,
      cost: newMYRCost,
    };

    putRequest(`/admin/global-rates-update`, data, access_token.token, (res) => {
      if (res.success) {
        onClose();
        setShowConfirmModal(false);
        getGlobalRatesData();
        setAlertState({
          message: 'Global rate has been updated successfully',
          show: true,
          variant: 'success',
        });
      } else {
        setAlertState({
          message: 'Failed to update rate',
          show: true,
          variant: 'danger',
        });
      }
    });
  };

  useEffect(() => {
    if (rowData) {
      setnewMYRCost(myr_cost);
    }
  }, [rowData]);

  useEffect(() => {
    if (alertState.show) {
      setTimeout(() => {
        setAlertState({
          message: '',
          show: false,
          variant: '',
        });
      }, config.notify_time);
    }
  }, [alertState]);

  return (
    <>
      <CustomAlert
        message={alertState.message}
        show={alertState.show}
        variant={alertState.variant}
        closeAlert={() => setAlertState({ show: false, variant: 'danger', message: '' })}
      />
      <Modal show={show} onHide={onClose}>
        <Modal.Body>
          <CloseIcon handleModalClose={onClose} />
          <Modal.Title>Update Global Rate</Modal.Title>
          <Form.Group>
            <Form.Label>Name</Form.Label>
            <Form.Control type="text" value={name} />
          </Form.Group>
          <Form.Group>
            <Form.Label>Country</Form.Label>
            <Form.Control type="text" value={country} />
          </Form.Group>
          <Form.Group>
            <Form.Label>Cost (MYR)</Form.Label>
            <Form.Control
              type="number"
              value={newMYRCost}
              onChange={(e) => setnewMYRCost(e.target.value)}
            />
          </Form.Group>
          <div style={{ display: 'flex', justifyContent: 'flex-start', gap: '10px' }}>
            <Button variant="primary" onClick={showConfirm} style={{ minWidth: 160 }}>
              Update
            </Button>
            <Button variant="ghost" onClick={onClose} style={{ minWidth: 160 }}>
              Cancel
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      <GlobalRatesConfirmModel
        show={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
        handleEditRate={handleEditRate}
        name={name}
        originalCost={myr_cost}
        newCost={newMYRCost}
      />
    </>
  );
};

export default GlobalRatesUpdateModel;
